import React from 'react'

import { VStack } from '~/components/elements/VStack'

import {
  RowDisplayToggleFormItem,
  type RowDisplayToggleFormItemProps,
} from './RowDisplayToggleFormItem'

export type RowDisplayToggleFormProps<RowId extends number | string> = {
  items: RowDisplayToggleFormItemProps<RowId>['item'][]
  onChange?: RowDisplayToggleFormItemProps<RowId>['onChange']
}

export const RowDisplayToggleForm = <RowId extends number | string>({
  items,
  onChange,
}: RowDisplayToggleFormProps<RowId>) => (
  <VStack spacing={4}>
    {items.map((item) => (
      <RowDisplayToggleFormItem
        key={item.label}
        item={item}
        onChange={onChange}
      />
    ))}
  </VStack>
)
